import { TableHeader } from 'src/app/shared/classes/table';
import { InforceTablePolicy } from '../models/inforceTablePolicy.model';

export const InforceTableHeaders: TableHeader<InforceTablePolicy>[] = [
  {
    DisplayName: 'Agent',
    ColumnName: ['Agent'],
    WidthClass: 'min-w-128',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.Agent ?? '';
      const valB = b.Agent ?? '';
      return (valA === valB ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Clients',
    ColumnName: ['Clients'],
    WidthClass: 'min-w-128',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.Clients ?? '';
      const valB = b.Clients ?? '';
      return (valA === valB ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Carrier',
    ColumnName: ['Carrier'],
    WidthClass: 'min-w-128',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.Carrier ?? '';
      const valB = b.Carrier ?? '';
      return (valA === valB ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Policy',
    ColumnName: ['Product'],
    WidthClass: 'min-w-256',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.Product ?? '';
      const valB = b.Product ?? '';
      return (valA === valB ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Latest Status',
    ColumnName: ['PolicyStatusDate'],
    WidthClass: '',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.PolicyStatusDate ?? new Date(1900, 1, 1);
      const valB = b.PolicyStatusDate ?? new Date(1900, 1, 1);
      return (valA.getTime() === valB.getTime() ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Effective Date',
    ColumnName: ['InforceDate'],
    WidthClass: '',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.InforceDate ?? new Date(1900, 1, 1);
      const valB = b.InforceDate ?? new Date(1900, 1, 1);
      return (valA.getTime() === valB.getTime() ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Issued Premium',
    ColumnName: ['Premium'],
    WidthClass: '',
    CompareFn: (a: InforceTablePolicy, b: InforceTablePolicy, order: 1|-1):number => {
      if (a.ActionNeeded !== b.ActionNeeded) {
        return a.ActionNeeded ? -1 : 1;
      }
      const valA = a.Premium;
      const valB = b.Premium;
      if (valA != null && valB != null) return (valA === valB ? 0 : valA > valB ? 1 : -1) * order;
      if (valA === valB) return 0;
      return (valA === null ? -1 : 1) * order;
    },
  }
];